<template>
  <div class="dropdown d-inline ">
    <soft-button v-show="statusSelected == ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2' 
      data-bs-toggle="dropdown" aria-expanded="false">{{ $t('key_filter_status') }}</soft-button>
    <soft-button v-show="statusSelected != ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2 active-filter' 
      data-bs-toggle="dropdown" aria-expanded="false">{{ $t('key_filter_status') }}</soft-button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="navbarDropdownMenuLink2">
      <li>
        <button class="dropdown-item border-radius-md text-saved" :class="[statusSelected=='REGISTRADO'? 'active':'']" type="button" @click="handleClick('REGISTRADO')" >{{ $t('key_orderStatus_saved') }}</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-error" :class="[statusSelected=='NO_REGISTRADO'? 'active':'']" type="button" @click="handleClick('NO_REGISTRADO')">{{ $t('key_filters_status_not_registered') }}</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-processing" :class="[statusSelected=='EN_PROCESO'? 'active':'']" type="button" @click="handleClick('EN_PROCESO')">{{ $t('key_orderStatus_inProcess') }}</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-fullfilled" :class="[statusSelected=='FINALIZADO'? 'active':'']" type="button" @click="handleClick('FINALIZADO')">{{ $t('key_orderStatus_finished') }}</button>
      </li>    
      <li>
        <button class="dropdown-item border-radius-md text-cancelled" :class="[statusSelected=='CANCELADO'? 'active':'']" type="button" @click="handleClick('CANCELADO')">{{ $t('key_orderStatus_cancelled') }}</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-onhold" :class="[statusSelected=='RETENIDO'? 'active':'']" type="button" @click="handleClick('RETENIDO')">{{ $t('key_orderStatus_onhold') }}</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-primary" type="button" @click="handleClick('')">{{ $t('key_orderStatusFilter_clearFilter') }}</button>
      </li>
    </ul>
  </div>
</template>

<script>

  import SoftButton from "@/components/SoftButton.vue";

  export default {
    name:"OrdersFilter",
    components: {
      SoftButton, 
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => '',
      },
    },
    emits: ['filter-change'],
    data() {
      return {
        statusSelected:"",
      }
    },
    computed: {
      listFilters() {
        return this.$store.state.order.listFilters;
      },
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected
      }
    },
    mounted() {
      this.setUpFilters()
    },
    methods: {
      handleClick(status) {
        this.statusSelected=status
        this.$emit('filter-change',status)
      },
      setUpFilters() {
        if (Object.keys(this.listFilters).length > 0) {

          const { filters } = this.listFilters

          if (filters['status']) {
            this.statusSelected = filters['status']
          }
        }
      }
    }
  }

</script>

<style scoped>

  .active{
    background-color: rgb(234, 244, 247) !important;
  }
  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }

</style>